// extracted by mini-css-extract-plugin
module.exports = {"Menu":"bhg_a bhu_h","Menu__offsetParent":"bhg_b bhu_bj","Menu__trigger--shadowed":"bhg_c"};